import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { useTheme } from '@shared/theme/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="h-8 w-8 text-navbar-muted hover:text-navbar-foreground hover:bg-navbar-accent shrink-0"
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
};
